/** @jsxImportSource theme-ui */
import React from 'react';

import { Typography } from 'components/_common/Typography';

type BdFormLabelProps = {
  marginTop?: string;
};

const BdFormLabel: React.FC<BdFormLabelProps> = ({ marginTop = '10px', children }) => (
  <Typography variant="body2" color="stone90" sx={{ mt: marginTop }}>
    {children}
  </Typography>
);

export const BdFormSection: React.FC = ({ children }) => <div sx={{ mt: '10px' }}>{children}</div>;

export default BdFormLabel;
